const maxInfantAge = 2;
export function getNonInfantsCount({ adults, childAges }) {
    return (adults || 0) + childAges.filter((a) => a >= maxInfantAge).length;
}
